import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

class ShippingInfo extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateShippingInfo);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateShippingInfo);
  }

  /**
   * Updates the shipping info when variant changes.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateShippingInfo = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newShippingInfo = event.detail.data.html.querySelector('shipping-info');

    if (!newShippingInfo) return;

    morph(this, newShippingInfo, { childrenOnly: true });
    this.dataset.deliveryText = newShippingInfo.dataset.deliveryText || '';
  };
}

if (!customElements.get('shipping-info')) {
  customElements.define('shipping-info', ShippingInfo);
}
